PJQ.collections.budget = PJQ.collections.budget ? PJQ.collections.budget : {};
PJQ.models.budget = PJQ.models.budget ? PJQ.models.budget : {};
PJQ.views.budget = PJQ.views.budget ? PJQ.views.budget : {};

PJQ.helpers.costCodes = {
    getDivisionSortValue: function (division) {
        if (_.size(division) === 0 || division.toLowerCase() === 'no division') {
            return -1;
        }

        let numsOnly = PJQ.helpers.formatHelpers.numbersOnly(division);
        if (_.size(numsOnly) > 0) {
            let num = parseInt(numsOnly);
            if (!isNaN(num)) {
                return num;
            }
        }
        return division;
    },
    sortDivisions: function (divisions) {
        return _.sortBy(divisions, function (division) {
            return PJQ.helpers.costCodes.getDivisionSortValue(division.name);
        })
    }
}

PJQ.helpers.erp = {
    renderERPButtons: function ($el, options) {
        options = _.defaults(options, {
            pushSupported: false,
            canPush: options.pushSupported === true,
            canPushChanges: options.pushSupported === true,
            disablePushReason: null,
            pullSupported: false,
            canPull: options.pullSupported === true,
            disablePullReason: null,
            canUnlink: options.unlinkSupported === true,
            canLink: options.linkSupported === true
        });

        let html = '';
        options.isStale = options.status === PJQ.constants.integrations.erp.syncStatuses.STALE;
        options.isPending = options.status === PJQ.constants.integrations.erp.syncStatuses.PENDING;
        options.isReviewing = options.status === PJQ.constants.integrations.erp.syncStatuses.REVIEWING;
        options.isApproved = options.status === PJQ.constants.integrations.erp.syncStatuses.APPROVED;
        options.isFailed = options.status === PJQ.constants.integrations.erp.syncStatuses.FAILED;
        options.isSynced = options.status === PJQ.constants.integrations.erp.syncStatuses.SYNCED;
        options.isRejected = options.status === PJQ.constants.integrations.erp.syncStatuses.REJECTED;
        if (options.isSynced) {
            options.canPush = false;
            options.disablePushReason = "No changes to sync";
        } else if (options.isApproved) {
            options.canPush = false;
            options.canPull = false;
            options.disablePushReason = "Approved - Sync to ERP system in process";
            options.disablePullReason = "Approved - Sync to ERP system in process";
        }

        if (options.pushSupported) {
            if (options.isReviewing) {
                html += `<button type="button" class="btn btn-outline-dark btn-undo-push-erp" title="Undo and remove from ERP Approval">
                    <i class='fal fa-rotate-left mr-1'></i>Undo Push to ERP
                </button>`;
            } else if ((options.canPushChanges && (options.isSynced || options.isStale)) || ((options.isRejected || options.isFailed || options.isPending) && options.pushSupported)) {
                html += `<button type="button" class="btn btn-outline-dark btn-push-erp"
                    <%= canPush ? '' : 'disabled' %>
					title='<%= !canPush && _.size(disablePushReason) > 0 ? disablePushReason : 'Send to your ERP system' %>'>
                    <i class='fal fa-arrow-up-to-line mr-1'></i><%= isStale || isSynced ? 'Push Changes to ERP' : 'Push to ERP' %>
                </button>`;
            }
        }

        if (options.pullSupported && (options.canPull || options.status == null || options.isSynced)) {
            html += `<button type="button" class="btn btn-outline-dark btn-pull-erp" 
                    <%= canPull ? '' : 'disabled' %>
					title='<%= !canPull && _.size(disablePullReason) > 0 ? disablePullReason : 'Refresh from your ERP system' %>'>
                    <i class='fal fa-arrow-down-to-line mr-1'></i>Pull from ERP
                </button>`;
        }

        if (options.canLink && options.isPending) {
            html += `<button type="button" class="btn btn-outline-dark btn-link-erp" title="Link to your ERP system">
                    <i class='fal fa-link mr-1'></i>Link to ERP
                    </button>`;
        } else if (options.canUnlink && options.isSynced) {
            html += `<button type="button" class="btn btn-outline-dark btn-unlink-erp" title="Unlink from your ERP system">
                    <i class='fal fa-link-slash mr-1'></i>Unlink from ERP
                    </button>`;
        }

        if (_.size(html) > 0) {
            $el.html(PJQ.templating.TemplateRenderer.parseMarkup(html, options));
        } else {
            $el.empty();
        }

        return {
            pulling: (isPulling) => {
                if (isPulling) {
                    this.pullingLoader = new PJQ.Loader($el.find('.btn-pull-erp'), {
                        loadingText: null
                    });
                } else if (this.pullingLoader) {
                    this.pullingLoader.remove();
                    this.pullingLoader = null;
                }
            },
            pushing: (isPushing) => {
                if (isPushing) {
                    this.pushingLoader = new PJQ.Loader($el.find('.btn-push-erp'), {
                        loadingText: null
                    });
                } else if (this.pushingLoader) {
                    this.pushingLoader.remove();
                    this.pushingLoader = null;
                }
            },
            unlinking: (isUnlinking) => {
                if (isUnlinking) {
                    this.unlinkLoader = new PJQ.Loader($el.find('.btn-unlinking-erp'), {
                        loadingText: null
                    });
                } else if (this.unlinkLoader) {
                    this.unlinkLoader.remove();
                    this.unlinkLoader = null;
                }
            }
        };
    },
    getERPIcon: function (status) {
        let iconClass = '',
            colorClass = '';
        switch (status) {
            case PJQ.constants.integrations.erp.syncStatuses.REVIEWING:
                iconClass = 'fa-clock';
                colorClass = 'text-primary';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.REJECTED:
                iconClass = 'fa-triangle-exclamation';
                colorClass = 'text-warning';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.APPROVED:
                iconClass = 'fa-link-simple';
                colorClass = 'text-purple';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.SYNCED:
                iconClass = 'fa-link-simple';
                colorClass = 'text-success';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.FAILED:
                iconClass = 'fa-link-simple-slash';
                colorClass = 'text-danger';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.STALE:
                iconClass = 'fa-link-simple';
                colorClass = 'text-secondary';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.PENDING:
            default:
                return '';
        }
        return '<i class="fas ' + iconClass + ' fs-14 ' + colorClass + '" title="' + PJQ.constants.integrations.erp.syncStatusDescriptions[status] + '"></i>';
    },
    getERPBadge: function (status, externalObject, options) {
        let badgeClass = '',
            badgeIcon = '';
        switch (status) {
            case PJQ.constants.integrations.erp.syncStatuses.REVIEWING:
                badgeIcon = 'fa-clock';
                badgeClass = 'badge-primary';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.REJECTED:
                badgeIcon = 'fa-triangle-exclamation';
                badgeClass = 'badge-danger';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.APPROVED:
                badgeIcon = 'fa-link-simple';
                badgeClass = 'badge-purple';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.SYNCED:
                badgeIcon = 'fa-link-simple';
                badgeClass = 'badge-success';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.FAILED:
                badgeIcon = 'fa-link-simple-slash';
                badgeClass = 'badge-danger';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.STALE:
                badgeIcon = 'fa-link-simple';
                badgeClass = 'badge-secondary';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.PENDING:
            default:
                return '';
        }

        let text = '',
            appendText = '',
            title = PJQ.constants.integrations.erp.syncStatusDescriptions[status];
        if (externalObject != null) {
            if (externalObject.data != null && _.size(externalObject.data.externalNumber) > 0) {
                text = '<span class="font-weight-light ml-2 fs-13 lh-14"><span class="font-weight-medium mr-1"></span>' + externalObject.data.externalNumber + '</span>'
            }

            if (externalObject.status === PJQ.constants.integrations.erp.syncStatuses.REJECTED && _.size(externalObject.rejectReason) > 0) {
                title = externalObject.rejectReason;
            } else if (externalObject.status === PJQ.constants.integrations.erp.syncStatuses.FAILED && _.size(externalObject.error) > 0) {
                title = externalObject.error;
            }
        }
        return '<span title="' + title + '" data-toggle="tooltip" data-placement="bottom" class="badge badge-erp ' + badgeClass + '"><i class="far fs-14 text-white ' + badgeIcon + '"></i>' + text + '</span>' + appendText;
    }
};

PJQ.modules.budget = {
    routes: [
        {
            route: "budget",
            name: 'budget',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "budget"
                });
            }
        },
        {
            route: 'projects/:projectId/budget',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "budget");
            }
        },
        {
            route: 'projects/:projectId/costcodes',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "costcodes");
            }
        },
        {
            route: 'projects/:projectId/subjobs',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "subjobs");
            }
        }
    ]
};

PJQ.constants.budgetHelpers = {
    columnTypes: {
        SOURCE: 'source',
        CALCULATED: 'calculated'
    },
    columnFormats: {
        MONEY: 'money',
        PERCENT: 'percent',
        INTEGER: 'int'
    },
    getColumnSources: function () {
        let def = PJQ.constants.budgetHelpers.columnSources;
        if (PJQ.app.session.erpIntegration != null) {
            return _.union(def, _.map(PJQ.app.session.erpIntegration.getBudgetColumns(), function (col) {
                return _.extend(col, {isErp: true});
            }));
        }
        return def;
    },
    columnSources: [
        {
            name: 'Description',
            source: 'Description',
            canCalculate: false,
            format: 'string'
        },
        {
            name: 'Budgeted Hours',
            source: 'BudgetedHours',
            canCalculate: true,
            format: 'time'
        },
        {
            name: 'Original Budget',
            source: 'BudgetedCost',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Budget Modifications',
            source: 'BudgetModification',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Revised Budget',
            source: 'RevisedBudget',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Pending Budget Changes',
            source: 'PendingBudgetChanges',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Projected Budget',
            source: 'ProjectedBudget',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Contracts',
            source: 'PrimeContractValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Contract Change Orders',
            source: 'PrimeContractChangeOrderValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Committed Costs',
            source: 'CommittedCosts',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Pending Cost Changes',
            source: 'PendingCosts',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Commitments',
            source: 'CommitmentValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Commitment Change Orders',
            source: 'CommitmentChangeOrderValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Direct Costs',
            source: 'DirectCostValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Payable Invoices',
            source: 'PayableInvoiceValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Payable Invoice Payments',
            source: 'PayablePayments',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Receivable Invoices',
            source: 'ReceivableInvoiceValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Receivable Invoice Payments',
            source: 'ReceivablePayments',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Time Cards',
            source: 'TimeCardValues',
            canCalculate: true,
            isSource: true,
            format: 'decimal'
        },
        {
            name: 'Projected Costs',
            source: 'ProjectedCosts',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Forecast To Complete',
            source: 'ForecastToComplete',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Notes',
            source: 'Notes',
            canCalculate: false,
            format: 'string'
        },
        {
            name: 'Unit Price',
            source: 'UnitPrice',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Quantity',
            source: 'Quantity',
            canCalculate: true,
            format: 'integer',
        }
    ]
}

PJQ.app.addRoutes(PJQ.modules.budget.routes);
